import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  .new-token-container {
    display: flex;
  }

  .new-token-container-left {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    width: 70%;

    gap: 0px 24px;
  }

  .new-token-container-right {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    gap: 8px 24px;
    position: relative;
    .preview {
      color: ${Theme.pallete.PRIMARY};

      text-align: center;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 300;
      line-height: 24px;
    }
  }

  .new-token-title {
    width: 100%;
    max-height: 23px;

    color: #000;

    margin-bottom: 32px;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .new-token-subtitle {
    display: flex;
    align-items: center;

    width: 100%;
    height: 23px;

    margin-bottom: 16px;

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  .new-token-div-juros {
    display: flex;
    justify-content: space-around;

    width: 316px;
  }

  .new-token-plus {
    margin-top: 12px;
    color: var(--Cinza-claro, #9c948c);
    text-align: center;

    /* A - Link ou legendas - Light */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }

  .color-picker-container {
    display: flex;

    gap: 24px;

    margin-bottom: 32px;
  }

  .span-1 {
    color: var(--Preto-Principal, #1c1d22);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
    text-decoration-line: underline;

    margin-bottom: 16px;
  }

  .span-2 {
    color: var(--cinza-6-mdio-9-e, #9e9e9e);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;

    margin-bottom: 16px;
  }

  .recomendations {
    color: var(--cinza-7-cinza-novo-75, #757575);
    font-family: Inter;
    font-size: 8px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px; /* 150% */
  }

  .recomendations-item {
    color: var(--cinza-5-mdio-bd, #bdbdbd);
    font-family: Inter;
    font-size: 8px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 150% */
  }

  .recomendations-container {
    display: flex;
    flex-direction: column;
  }

  .span-3 {
    color: var(--Blue-02-1, #3e788a);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
  }
`
export const InputError = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  padding: 5px 0;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
